import React, { useEffect, useMemo, useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { useContractAction, useTokenStatus } from "../../hooks";

import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import { ModalBody } from "reactstrap";

import {
	Button,
	Card,
	CardBody,
	Accordion,
	AccordionBody,
	AccordionHeader,
	AccordionItem,
	Row,
	Col,
} from "reactstrap";

import Avatar from "../Avatar";

import { burnToken, transToken } from "../../store/actions/token";
import TokensModal from "./TokensModal";
import CopyClipboard from "../common/CopyClipboard";
import ActionModal from "../common/ActionModal";

export default function AssetsToken({ tokenId }) {
	const [openActionModal, setOpeActionModal] = useState(false);
	const [actionModalType, setActionModalType] = useState(undefined);
	const [showAvatarPreview, setShowAvatarPreview] = useState(false);

	// useEffect(() => {
	// 	console.log("showAvatarPreview", showAvatarPreview);
	// }, [showAvatarPreview]);

	const handleOpenActionModal = () => setOpeActionModal(true);
	const handleCloseActionModal = () => {
		setActionModalType(undefined);
		setOpeActionModal(false);
	};
	const tokens = useSelector((state) => state.token.items);
	const contracts = useSelector((state) => state.contract.items);
	const { deleteToken, transferToken, show, stage, error, action } =
		useContractAction();
	const dispatch = useDispatch();
	const { getTokenTotal } = useTokenStatus();
	const history = useHistory();

	const [token, setToken] = useState(null);
	const [tokenOwner, setTokenOwner] = useState(null);
	const [openProperties, setOpenProperties] = useState("");

	const toggleProperties = (id) => {
		openProperties === id ? setOpenProperties() : setOpenProperties(id);
	};

	const item = tokens.find((item) => item._id === tokenId);
	const contract = useMemo(
		() =>
			contracts.length > 0 && token
				? contracts.find((item) => item._id === token.contractId)
				: {},
		[contracts, token]
	);
	useEffect(() => {
		setToken(item);
		if (contract && token) {
			getTokenTotal(tokenId).then((res) => {
				setTokenOwner(res);
			});
		}
		return () => {
			setTokenOwner(null);
		};
	}, [tokens, item, contract, getTokenTotal, token, tokenId]);

	const renderUserImg = () => {
		if (token !== null && token?.image) {
			return (
				<Box sx={{ minWidth: "240px" }}>
					{token?.imageType?.includes("image") && (
						<Box
							component="img"
							className="img-fluid rounded mt-3 mb-2"
							sx={{
								maxHeight: "260px",
								mr: "1rem",
							}}
							alt="token-avatar"
							src={`${process.env.REACT_APP_IPFS_HOST}/${token?.image}`}
						/>
					)}
					{token?.imageType?.includes("video") && (
						<Box
							component="video"
							className="img-fluid rounded mt-3 mb-2"
							sx={{
								maxHeight: "260px",
								mr: "1rem",
							}}
							src={`${process.env.REACT_APP_IPFS_HOST}/${token?.image}`}
							poster={`${process.env.REACT_APP_IPFS_HOST}/${token?.cover}`}
							controls
						/>
					)}
					{token?.imageType?.includes("audio") && (
						<Box
							sx={{
								display: "flex",
								flexWrap: "wrap",
								alignItems: "end",
								mr: "1rem",
							}}
						>
							<Box
								component="img"
								src={`${process.env.REACT_APP_IPFS_HOST}/${token?.cover}`}
								sx={{
									width: "100%",
									maxHeight: "260px",
									pb: "1rem",
								}}
							/>
							<Box
								component="audio"
								sx={{
									display: "block",
									width: "245px",
								}}
								src={`${process.env.REACT_APP_IPFS_HOST}/${token?.image}`}
								controls
							/>
						</Box>
					)}
				</Box>
			);
		} else {
			const stateNum = Math.floor(Math.random() * 6),
				states = [
					"light-success",
					"light-danger",
					"light-warning",
					"light-info",
					"light-primary",
					"light-secondary",
				],
				color = states[stateNum];
			return (
				<Avatar
					initials
					color={color}
					className="rounded mt-3 mb-2"
					content={token?.name || "Anonymous"}
					contentStyles={{
						borderRadius: 6,
						fontSize: "calc(48px)",
						width: "100%",
						height: "100%",
					}}
					style={{
						height: "110px",
						width: "110px",
					}}
				/>
			);
		}
	};
	const actiopProps = () => {
		const transferProps = {
			header: "Transfer token",
			text: "Enter the wallet address of the new owner.",
			type: contract.type,
			count: tokenOwner?.balanceOf,
			modalType: "transfer",
		};
		const deleteProps = {
			header: "Delete token",
			text: "Burning a token is irrevocable. By clicking submit you confirm your desire.",
			type: contract.type,
			count: tokenOwner?.balanceOf,
			modalType: "delete",
		};
		if (actionModalType === "transfer") {
			return transferProps;
		}
		if (actionModalType === "delete") {
			return deleteProps;
		} else return {};
	};

	const hendleCloneToken = () => {
		history.replace(`/contracts/mint/clone/${contract._id}/${token._id}`);
	};
	const hendleCopyToken = () => {
		history.replace(`/contracts/mint/copy/${contract._id}/${token._id}`);
	};
	const handleSubmit = (data, actionType) => {
		const { address, count } = data;
		if (actionType === "transfer") {
			handleCloseActionModal();

			transferToken(address, token, count)
				.then((res) => {
					dispatch(transToken(tokenId, res.gasUsed));
				})
				.then(() => history.replace(`/contracts/token/${token._id}`))
				.catch((error) => {
					console.log(error.message);
					history.replace(`/contracts/token/${token._id}`);
				});
		}
		if (actionType === "delete") {
			handleCloseActionModal();
			deleteToken(token, count)
				.then((res) => dispatch(burnToken(tokenId, res.gasUsed, count)))
				.catch((error) => console.log(error.message));
		}
	};
	const hendleTransferToken = () => {
		setActionModalType("transfer");
		handleOpenActionModal();
	};
	const hendleDeleteToken = () => {
		setActionModalType("delete");
		handleOpenActionModal();
	};

	return (
		<>
			<Box
				sx={{
					minHeight: "78vh",
					margin: "0 auto",
					width: "100%",
				}}
				maxWidth="md"
			>
				<Dialog
					open={showAvatarPreview}
					disableEscapeKeyDown
					// maxWidth="md"
					// fullWidth
					onClose={() => setShowAvatarPreview(false)}
					sx={{
						maxWidth: "1000px",
						m: "0 auto",
						height: "calc(100% - 64px)",
						width: "100%",
						"& div.MuiDialog-paper": {
							maxWidth: "1000px",
						},
					}}
				>
					<Box className="py-2" sx={{ width: "100%" }}>
						{token?.imageType?.includes("image") && (
							<Box
								component="img"
								sx={{
									width: "100%",
									p: "1rem",
								}}
								alt="token-avatar"
								src={`${process.env.REACT_APP_IPFS_HOST}/${token?.image}`}
							/>
						)}
						{token?.imageType?.includes("video") && (
							<Box
								component="video"
								sx={{
									width: "100%",
									p: "1rem",
								}}
								src={`${process.env.REACT_APP_IPFS_HOST}/${token?.image}`}
								poster={`${process.env.REACT_APP_IPFS_HOST}/${token?.cover}`}
								controls
							/>
						)}
						{token?.imageType?.includes("audio") && (
							<Box
								sx={{
									display: "flex",
									flexWrap: "wrap",
									alignItems: "end",
								}}
							>
								<Box
									component="img"
									src={`${process.env.REACT_APP_IPFS_HOST}/${token?.cover}`}
									sx={{
										width: "100%",
										p: "1rem",
									}}
								/>
								<Box
									component="audio"
									sx={{
										display: "block",
										width: "450px",
										m: "0 auto",
									}}
									src={`${process.env.REACT_APP_IPFS_HOST}/${token?.image}`}
									controls
								/>
							</Box>
						)}
					</Box>
				</Dialog>

				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						flexBasis: "75%",
					}}
				>
					<Box
						sx={{
							minHeight: "78vh",
							margin: "0 auto",
							width: "100%",
						}}
					>
						<Card className="mb-3">
							<CardBody
								style={{
									paddingLeft: "1rem",
									paddingRight: "1rem",
								}}
							>
								<div className="d-flex">
									<div
										className="user-avatar-section me-2"
										onClick={() => setShowAvatarPreview(true)}
										style={{
											width: "250px",
											minHeight: "110px",
											minWidth: "110px",
											textAlign: "center",
											cursor: "pointer",
										}}
									>
										{renderUserImg()}
									</div>
									<div className="info-container" style={{ minWidth: "70%" }}>
										<div className="border-bottom pb-50 mb-1 d-flex justify-content-between">
											<h5 className="fw-bolder ">Details</h5>
											<div>
												<Button
													className="px-4 me-3"
													color="primary"
													onClick={hendleCloneToken}
												>
													Clone
												</Button>
												<Button
													className="px-4 me-3"
													color="primary"
													onClick={hendleCopyToken}
												>
													Copy
												</Button>
												{tokenOwner?.owned && (
													<>
														<Button
															className="px-4 me-3"
															color="primary"
															onClick={hendleTransferToken}
														>
															Transfer
														</Button>
														<Button
															className="px-4 me-3"
															color="primary"
															onClick={hendleDeleteToken}
														>
															Delete
														</Button>
													</>
												)}
											</div>
										</div>
										<table className="mt-2 mt-xl-0 w-100">
											<tbody>
												<tr className="table-row">
													<th>Name</th>
													<td>{token?.name || "No info"}</td>
												</tr>
												<tr className="table-row">
													<th>Token ID</th>
													<td>{token?.tokenID || "No info"}</td>
												</tr>
												{tokenOwner?.type === "ERC721" ? (
													<tr className="table-row">
														<th>Owned</th>
														<td>{tokenOwner.owned ? "Yes" : "No"}</td>
													</tr>
												) : tokenOwner?.type === ("ERC1155" || "ERC20") ? (
													<tr className="table-row">
														<th>Owned</th>
														<td>
															{tokenOwner.balanceOf}({token?.amount})
														</td>
													</tr>
												) : null}

												{tokenOwner?.type === "ERC721" ? (
													tokenOwner.burnt ? (
														<tr className="table-row">
															<th>Status</th>
															<td>Burnt</td>
														</tr>
													) : (
														!tokenOwner.balanceOf && (
															<tr className="table-row">
																<th>Owner</th>
																<td>
																	{tokenOwner.owner}
																	<CopyClipboard target={tokenOwner.owner} />
																</td>
															</tr>
														)
													)
												) : tokenOwner?.type === "ERC1155" &&
												  tokenOwner?.burnt ? (
													<tr className="table-row">
														<th>Burnt</th>
														<td>{tokenOwner.burnt}</td>
													</tr>
												) : null}
												{tokenOwner?.type === "ERC1155" &&
												token?.amount -
													tokenOwner?.burnt -
													tokenOwner?.balanceOf ? (
													<tr className="table-row">
														<th>Transferred</th>
														<td>
															{token.amount -
																tokenOwner.burnt -
																tokenOwner.balanceOf}
														</td>
													</tr>
												) : null}
												<tr className="table-row">
													<th>Minting GAS</th>
													<td>{token?.gas || 0}</td>
												</tr>
												{token?.burntGas !== 0 && (
													<tr className="table-row">
														<th>Burnt Gas</th>
														<td>{token?.burntGas || 0}</td>
													</tr>
												)}
												<tr className="table-row">
													<th>Asset IPFS</th>
													<td>
														<Button color="primary" outline>
															<a
																href={`${process.env.REACT_APP_IPFS_HOST}/${token?.image}`}
																target="_blank"
																rel="noreferrer"
															>
																Link
															</a>
														</Button>
													</td>
												</tr>
												<tr className="table-row">
													<th>Meta IPFS</th>
													<td>
														<Button color="primary" outline>
															<a
																href={`${process.env.REACT_APP_IPFS_HOST}/${token?.metadataLink}`}
																target="_blank"
																rel="noreferrer"
															>
																Link
															</a>
														</Button>
													</td>
												</tr>
												{/* ???? */}
												{token?.unlockableLink && (
													<tr className="table-row">
														<th>Unlockable content</th>
														<td>
															<Button
																color="primary"
																outline
																tag="a"
																href={`${process.env.REACT_APP_API_UNLOCK}/${token.unlockableLink}`}
																target="_blank"
																rel="noreferrer"
															>
																Link
															</Button>
														</td>
													</tr>
												)}
											</tbody>
										</table>
									</div>
								</div>
							</CardBody>
						</Card>
						<Card className="mb-3">
							<CardBody>
								<Row>
									<Col md={6} className="mb-3">
										<h5>Description</h5>
										<p>{token?.description || "No info"}</p>
									</Col>
									<Col md={6} className="mb-3">
										<h5>Price</h5>
										<p>{token?.price}</p>
									</Col>
									<Col md={6} className="mb-3">
										<h5>Royalties</h5>
										<p>{token?.royalties}</p>
									</Col>
									{token?.attributes.length > 0 && (
										<Col md={6} className="mb-3">
											<Accordion
												className="accordion-border"
												open={openProperties}
												toggle={toggleProperties}
											>
												<AccordionItem>
													<AccordionHeader targetId="1">
														Properties
													</AccordionHeader>
													<AccordionBody accordionId="1">
														<table className="mt-2 mt-xl-0 w-100">
															<tbody>
																{token.attributes.map((prop) => {
																	return (
																		<tr key={prop.trait_type}>
																			<th>{prop.trait_type}</th>
																			<td>{prop.value}</td>
																		</tr>
																	);
																})}
															</tbody>
														</table>
													</AccordionBody>
												</AccordionItem>
											</Accordion>
										</Col>
									)}
								</Row>
							</CardBody>
						</Card>
					</Box>
				</Box>
			</Box>

			<TokensModal show={show} stage={stage} error={error} action={action} />
			<ActionModal
				actionProps={actiopProps()}
				open={openActionModal}
				handleClose={handleCloseActionModal}
				handleSubmit={handleSubmit}
			/>
		</>
	);
}
